module.exports = __webpack_public_path__ + "images/emoji/dromedary_camel.e3a6292a9027e93af1a8.png";